import React, { useContext } from 'react';
import {
  ButtonPrimary,
  ButtonSecondary,
  ButtonTertiary,
  TextLinkProps,
  ButtonSecondaryProps,
  ButtonPrimaryProps,
  ButtonTertiaryProps,
  TextLink,
} from '@spotify-internal/encore-web-v6';
import {
  FrodorModulesContext,
  TrackingAttributes,
} from '@spotify-internal/frodor-modules';

export type LinkType = {
  children: React.ReactNode;
  href: string;
  external?: boolean;
  useInternalNavigation?: boolean; // should only ever be true if there is navigation set in the onLinkClick function
  track: TrackingAttributes;
  dataTestId?: string;
};

export const ButtonPrimaryLink = ({
  children,
  href,
  external = false,
  useInternalNavigation = false,
  track,
  dataTestId,
  ...buttonProps
}: LinkType & ButtonPrimaryProps) => {
  const { onLinkClick } = useContext(FrodorModulesContext);

  return (
    <ButtonPrimary
      data-testid={dataTestId}
      href={useInternalNavigation ? undefined : href}
      onClick={() => onLinkClick({ href, external, trackingAttributes: track })}
      {...buttonProps}
    >
      {children}
    </ButtonPrimary>
  );
};

export const ButtonSecondaryLink = ({
  children,
  href,
  external = false,
  useInternalNavigation = false,
  track,
  dataTestId,
  ...buttonProps
}: LinkType & ButtonSecondaryProps) => {
  const { onLinkClick } = useContext(FrodorModulesContext);

  return (
    <ButtonSecondary
      data-testid={dataTestId}
      href={useInternalNavigation ? undefined : href}
      onClick={() => onLinkClick({ href, external, trackingAttributes: track })}
      {...buttonProps}
    >
      {children}
    </ButtonSecondary>
  );
};

export const ButtonTertiaryLink = ({
  children,
  href,
  external = false,
  useInternalNavigation = false,
  track,
  dataTestId,
  ...buttonProps
}: LinkType & ButtonTertiaryProps) => {
  const { onLinkClick } = useContext(FrodorModulesContext);

  return (
    <ButtonTertiary
      data-testid={dataTestId}
      condensedAll
      href={useInternalNavigation ? undefined : href}
      onClick={() => onLinkClick({ href, external, trackingAttributes: track })}
      {...buttonProps}
    >
      {children}
    </ButtonTertiary>
  );
};

export const FrodorTextLink = ({
  children,
  href,
  external = false,
  useInternalNavigation = false,
  track,
  dataTestId,
  ...buttonProps
}: LinkType & TextLinkProps) => {
  const { onLinkClick } = useContext(FrodorModulesContext);

  return (
    <TextLink
      data-testid={dataTestId}
      component={useInternalNavigation ? 'button' : 'a'}
      href={useInternalNavigation ? '' : href}
      target={external ? '_blank' : undefined}
      onClick={() => onLinkClick({ href, external, trackingAttributes: track })}
      {...buttonProps}
    >
      {children}
    </TextLink>
  );
};
